var _linearGradient, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafariOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 295.835,
    y1: 274.049,
    x2: 295.835,
    y2: 272.933,
    gradientTransform: "matrix(112 0 0 -112 -33069.5 30695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E64F0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    cx: 64,
    cy: 64,
    r: 62.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "none",
    d: "M64 7.6v9.2m0 94.1v9.2M73.8 8.5l-1.6 9.1m-16.4 92.5l-1.6 9.1M83.2 11l-3.1 8.7M47.9 108l-3.1 8.7M54.2 8.5l1.6 9.1m16.4 92.5l1.6 9.1M44.8 11l3.1 8.7M80.1 108l3.1 8.7M35.9 15.2l4.6 8m47 81.4l4.6 7.9M27.9 20.8l5.9 7m60.4 72.1l5.9 7M20.9 27.7l7.1 5.9m72 60.5l7.1 5.9M15.3 35.8l8 4.6m81.4 47l8 4.6M11.2 44.6l8.6 3.2m88.4 32.1l8.6 3.2M8.6 54.1l9.1 1.6M110.3 72l9.1 1.6M7.8 63.9H17m94 0h9.2M8.6 73.6l9.1-1.6m92.6-16.3l9.1-1.6m-108.2 29l8.6-3.2m88.4-32.1l8.6-3.2M15.3 92l8-4.6m81.4-47l8-4.6M20.9 100l7.1-5.9m72-60.5l7.1-5.9m-79.2 79.2l5.9-7m60.4-72.1l5.9-7m-64.2 91.7l4.6-7.9m47-81.4l4.6-8m-33-7.3l.4 5m9 102l.4 5M49.4 9.6l1.3 4.8m26.6 98.9l1.3 4.9M40.2 12.9l2.1 4.6m43.3 92.8l2.2 4.5m-56.1-97l2.9 4.1m58.8 83.9l2.9 4.1M24.2 24.1l3.6 3.5m72.4 72.5l3.6 3.5m-85.9-72l4.2 2.9m83.8 58.7l4.2 2.9m-97-56l4.5 2.1m92.8 43.3l4.5 2.1M9.7 49.3l4.9 1.3m98.8 26.5l4.9 1.3M8 58.9l5 .5m102 8.9l5 .5m-112 0l5-.5m102-8.9l5-.5M9.7 78.4l4.9-1.3m98.8-26.5l4.9-1.3M13.1 87.6l4.5-2.1m92.8-43.3l4.5-2.1m-97 56l4.2-2.9m83.8-58.7l4.2-2.9m-78.4 78.3l2.9-4.1m58.8-83.9l2.9-4.1m-56.1 97l2.2-4.5m43.2-92.8l2.2-4.6M49.4 118.2l1.3-4.9m26.6-98.9l1.3-4.8M59.1 119.9l.4-5m9-102l.4-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M106.7 21l-48 37.7 5.2 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D01414",
    d: "M63.9 63.9l6 6L106.7 21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.7 58.7l-37.7 48 42.9-42.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M21 106.7l48.9-36.8-6-6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariOriginal);
export default __webpack_public_path__ + "static/media/SafariOriginal.13bc5e4d183c37c8e6a2204a3e0df6da.svg";
export { ForwardRef as ReactComponent };